import moment from 'moment';

function toValidDate(m) {
  if (!m?.isValid()) {
    return null;
  }
  const date = m.toDate();
  return Number.isFinite(date.getTime()) ? date : null;
}

/** Parse Mongo $dateToString bucket keys from delivery metrics time series. */
export default function parseDeliveryPeriod(period, interval) {
  if (period == null || period === '') {
    return null;
  }

  const raw = String(period).trim();

  // Prefer bucket shape over interval — avoids NaN when RTK serves stale series.
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
    return toValidDate(moment(raw.slice(0, 10), 'YYYY-MM-DD', true).startOf('day'));
  }
  if (/^\d{4}-W\d{1,2}$/i.test(raw)) {
    return toValidDate(moment(raw.toUpperCase(), 'GGGG-[W]WW', true).startOf('isoWeek'));
  }
  if (/^\d{4}-\d{2}$/.test(raw)) {
    return toValidDate(moment(raw, 'YYYY-MM', true).startOf('month'));
  }

  if (interval === 'month') {
    return toValidDate(moment(raw, 'YYYY-MM', true).startOf('month'));
  }
  if (interval === 'week') {
    return toValidDate(moment(raw.toUpperCase(), 'GGGG-[W]WW', true).startOf('isoWeek'));
  }
  return toValidDate(moment(raw, 'YYYY-MM-DD', true).startOf('day'));
}
